/**
 * A helper function to announce messages to screen readers using an ARIA live region.
 * @param {string} message - The message to announce to screen readers.
 * @returns {void}
 */
export const announceAccessibilityMessage = (message) => {
  const region = document.getElementById('global-live-region');
  if (!region) return;

  region.textContent = '';

  setTimeout(() => {
    region.textContent = message;
  }, 100); // Small delay ensures VoiceOver picks it up
};
